export default "__VITE_ASSET__DLcnz4hM__"